import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface PieChartIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const PieChartIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: PieChartIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M2.63209 8.39912C1.92341 10.4045 1.90084 12.5919 2.55159 14.6041C3.20234 16.6162 4.49385 18.3005 6.23902 19.529C7.98419 20.7574 10.0927 21.4276 12.2584 21.4324C14.4241 21.4372 16.5358 20.7772 18.2865 19.5576C20.0372 18.3381 21.3374 16.6608 21.9983 14.6521C22.6591 12.6435 22.6468 10.456 21.9479 8.45308C21.249 6.45011 19.9621 4.7819 18.1972 3.57495C16.4323 2.36799 14.3141 1.73621 12.1329 1.76445L12.2707 11.7635L2.63209 8.39912Z"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
            <circle
                cx="12"
                cy="12"
                r="10"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeOpacity="0.12"
            />
        </svg>
    )
}

export default PieChartIcon
